var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubstep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6C11 6.74028 10.5978 7.38663 10 7.73244V16H13.2678C13.6136 15.4022 14.26 15 15.0002 15C16.1048 15 17.0002 15.8954 17.0002 17C17.0002 18.1046 16.1048 19 15.0002 19C14.26 19 13.6136 18.5978 13.2678 18H9.00024H9C8.44772 18 8 17.5523 8 17V7.73244C7.4022 7.38663 7 6.74028 7 6C7 4.89543 7.89543 4 9 4C10.1046 4 11 4.89543 11 6Z",
    fill: "#085B3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubstep);
export default __webpack_public_path__ + "static/media/substep.281ca5803ffd2d4313140dc5b5d6a737.svg";
export { ForwardRef as ReactComponent };